import semver from 'semver';

export const isVersionedUrl = (url: string): boolean => {
    if (!url.includes('unpkg.')) {
        return false;
    }

    const parts = url.split('@');

    return !!semver.clean(parts[parts.length - 1]);
};
